import styled from "styled-components";
import { LinkText } from "../../link";
export const DisabledLink = styled.span `
  color: ${({ theme }) => theme.colors.grey12};
  font-weight: ${({ theme }) => theme.fontWeights.normal};
`;
export const StyledLinkItem = styled.div `
  display: flex;
  align-items: center;

  &&& {
    a {
      box-sizing: border-box;
      min-width: auto;
      padding: 0 0.375rem;
      height: 2.5rem;

      & span > svg {
        fill: ${({ theme }) => theme.colors.grey15};
        width: 1rem;
        height: 1rem;
      }

      &:active {
        ${({ theme }) => theme.global.disableTapHighlight}

        span {
          color: ${({ theme }) => theme.colors.white};
        }

        svg {
          fill: ${({ theme }) => theme.colors.white};
        }
      }

      span {
        font-size: ${({ theme }) => theme.fontTokens.font12[0]};
        line-height: ${({ theme }) => theme.fontTokens.font12[1]};
        font-weight: ${({ theme }) => theme.fontWeights.medium};
        color: ${({ theme }) => theme.colors.grey15};
        padding: 0;
      }

      &:hover {
        ${({ theme }) => `background: rgba(${theme.colors.transparentBlack},0.08);`};
      }

      &:active {
        background: ${({ theme }) => theme.colors.grey15};
      }
    }
  }

  @media ${({ theme }) => theme.device.touch} {
    a {
      height: 2.75rem;
    }
  }

  span {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 1.5rem;
    height: 1.5rem;
  }
  &&& {
    & span > svg {
      width: 1rem;
      height: 1rem;
    }
  }

  &:not(:last-child) > span + span {
    margin-right: 0.375rem;
  }

  &:not(:first-child) > span + span {
    margin-left: 0.375rem;
  }

  ${LinkText}, ${DisabledLink} {
    width: auto;
    height: auto;
  }
`;
export const StyledHomeLinkItem = styled(StyledLinkItem) `
  &&& {
    a {
      padding-left: 0;
      min-width: unset;
    }
    span svg {
      width: 1rem;
      height: 1rem;
      padding: 0;
    }
    span {
      font-weight: ${({ theme }) => theme.fontWeights.medium};
      display: flex;
      justify-content: center;
      align-items: center;
    }

    span:not(${LinkText}) {
      padding: 0;
      min-width: 2.5rem;
      min-height: 2.5rem;
      > svg {
        width: 1rem;
        height: 1rem;
      }
    }
  }

  @media ${({ theme }) => theme.device.touch} {
    span:not(${LinkText}) {
      min-width: 2.75rem;
      min-height: 2.75rem;
    }
  }
`;
